import type { SpotifyContentType } from '@/lib/embed'

interface SpotifyEmbedProps {
    type: SpotifyContentType
    id: string
    title?: string
}

const COLLECTION_TYPES = new Set(['album', 'playlist', 'show', 'artist'])

export function SpotifyEmbed({ type, id, title }: SpotifyEmbedProps) {
    const isCollection = COLLECTION_TYPES.has(type)
    const height = isCollection ? 236 : 80

    return (
        <div
            className="rounded-lg overflow-hidden border border-border-light dark:border-border-dark"
            style={{ height }}
        >
            <iframe
                className="w-full h-full"
                src={`https://open.spotify.com/embed/${type}/${id}?utm_source=generator&theme=0`}
                // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- empty title should fall back to the default label, not render blank
                title={title || `Spotify ${type}`}
                allow="autoplay; encrypted-media; fullscreen; picture-in-picture"
                allowFullScreen
                loading="lazy"
                sandbox="allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
            />
        </div>
    )
}
